/**
 * Current Exhibition — rail arrow navigation (progressive enhancement).
 * Native scroll + scroll-snap remain the primary interaction.
 */
(function () {
  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initRail(shell) {
    if (!shell) return;

    // Tear down prior listeners (Theme Editor reloads / reorders)
    if (shell._exhibitionAbort) {
      shell._exhibitionAbort.abort();
    }

    var track = shell.querySelector('[data-exhibition-track]');
    var prev = shell.querySelector('[data-exhibition-prev]');
    var next = shell.querySelector('[data-exhibition-next]');
    if (!track) return;

    var abort = new AbortController();
    var signal = abort.signal;
    shell._exhibitionAbort = abort;
    shell.dataset.exhibitionReady = 'true';

    var scrolling = false;
    var scrollEndTimer = null;

    function cardStep() {
      var cell = track.querySelector('[data-exhibition-cell]');
      if (!cell) return track.clientWidth * 0.8;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return cell.getBoundingClientRect().width + gap;
    }

    function updateArrows() {
      if (!prev && !next) return;
      var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth - 1);
      var left = track.scrollLeft;
      if (prev) {
        var atStart = left <= 1;
        prev.disabled = atStart;
        prev.setAttribute('aria-disabled', atStart ? 'true' : 'false');
      }
      if (next) {
        var atEnd = left >= maxScroll;
        next.disabled = atEnd;
        next.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
      }
    }

    function scrollByDir(dir) {
      if (scrolling) return;
      if ((dir < 0 && prev && prev.disabled) || (dir > 0 && next && next.disabled)) {
        return;
      }

      scrolling = true;
      track.scrollBy({
        left: cardStep() * dir,
        behavior: prefersReducedMotion() ? 'auto' : 'smooth'
      });

      window.clearTimeout(scrollEndTimer);
      scrollEndTimer = window.setTimeout(
        function () {
          scrolling = false;
          updateArrows();
        },
        prefersReducedMotion() ? 50 : 420
      );
    }

    if (prev) {
      prev.addEventListener(
        'click',
        function () {
          scrollByDir(-1);
        },
        { signal: signal }
      );
    }
    if (next) {
      next.addEventListener(
        'click',
        function () {
          scrollByDir(1);
        },
        { signal: signal }
      );
    }

    track.addEventListener('scroll', updateArrows, { passive: true, signal: signal });

    // Keyboard: Left/Right when the rail itself is focused
    track.addEventListener(
      'keydown',
      function (event) {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          scrollByDir(-1);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          scrollByDir(1);
        } else if (event.key === 'Home') {
          event.preventDefault();
          track.scrollTo({
            left: 0,
            behavior: prefersReducedMotion() ? 'auto' : 'smooth'
          });
        } else if (event.key === 'End') {
          event.preventDefault();
          track.scrollTo({
            left: track.scrollWidth,
            behavior: prefersReducedMotion() ? 'auto' : 'smooth'
          });
        }
      },
      { signal: signal }
    );

    window.addEventListener('resize', updateArrows, { signal: signal });

    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(updateArrows);
      ro.observe(track);
      signal.addEventListener('abort', function () {
        ro.disconnect();
      });
    }

    updateArrows();
  }

  function initAll() {
    document.querySelectorAll('[data-exhibition-rail]').forEach(initRail);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;
    var shell = event.target.querySelector('[data-exhibition-rail]');
    if (shell) initRail(shell);
  });

  document.addEventListener('shopify:section:reorder', function () {
    initAll();
  });
})();
